/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface PaymentCardManageApiModel {
  /**
   * Business ID
   */
  business_id?: string | null;
  cards?: Array<string>;
  /**
   * Integration type used for payment(optional, for \'cardadd\' action on stripe only)
   */
  integration_type?: PaymentCardManageApiModelIntegrationTypeEnum;
  /**
   * Loyalty ID
   */
  loyalty_id?: string | null;
  /**
   * Pos ID
   */
  pos_id?: string | null;
  /**
   * Redirect URL if operation canceled (for \'cardadd\' action only)
   */
  redirect_cancel_url?: string;
  /**
   * Redirect URL if operation failed (for \'cardadd\' action only)
   */
  redirect_fail_url?: string;
  /**
   * Redirect URL if operation successful (for \'cardadd\' action only)
   */
  redirect_success_url?: string;
  /**
   * Terminal ID
   */
  terminal_id?: string | null;
}
export enum PaymentCardManageApiModelIntegrationTypeEnum {
  Checkout = 'checkout',
  Elements = 'elements'
}
